"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _taggedTemplateLiteral2 = require("babel-runtime/helpers/taggedTemplateLiteral");

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(["\n\tbackground-color: ", ";\n\t", ";\n\t"], ["\n\tbackground-color: ", ";\n\t", ";\n\t"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _cloudinaryCore = require("cloudinary-core");

var _cloudinaryCore2 = _interopRequireDefault(_cloudinaryCore);

var _reactImageloader = require("react-imageloader");

var _reactImageloader2 = _interopRequireDefault(_reactImageloader);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _recompose = require("recompose");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//------------------------------

var PRESET_NAME = "UnAuthed_LimitSize";
var CLOUDINARY_URL = "https://api.cloudinary.com/v1_1/codogo/upload";
var cl = _cloudinaryCore2.default.Cloudinary.new({ cloud_name: "codogo" });

var Preloader = _styledComponents2.default.div(_templateObject, function (_ref) {
	var theme = _ref.theme;
	return theme.colors.lightgray;
}, function (props) {
	if (props.width && props.height) {
		return "\n\t\t\t\twidth: " + props.width + "px;\n\t\t\t\theight: " + props.height + "px;\n\t\t\t";
	} else if (props.aspectRatio) {
		return "\n\t\t\t\twidth: 100%;\n\t\t\t\tpadding-top: " + 100 / props.aspectRatio + "%;\n\t\t\t";
	} else {
		return "\n\t\t\t\twidth: 100%;\n\t\t\t\tpadding-top: 75%;\n\t\t\t";
	}
});

var enhance = (0, _recompose.compose)((0, _recompose.withHandlers)({
	renderPreloader: function renderPreloader(props) {
		return function () {
			return _react2.default.createElement(Preloader, props);
		};
	}
}));

var CloudinaryImage = enhance(function (_ref2) {
	var cloudinaryID = _ref2.cloudinaryID,
	    cloudinaryId = _ref2.cloudinaryId,
	    height = _ref2.height,
	    transformation = _ref2.transformation,
	    transformationPreScale = _ref2.transformationPreScale,
	    transformations = _ref2.transformations,
	    transformationsPreScale = _ref2.transformationsPreScale,
	    url = _ref2.url,
	    width = _ref2.width,
	    renderPreloader = _ref2.renderPreloader;

	var allTransformations = [].concat((0, _toConsumableArray3.default)(transformationsPreScale || []), [transformationPreScale, {
		crop: "fit",
		dpr: window.devicePixelRatio,
		fetch_format: "auto",
		height: height,
		quality: "auto",
		width: width
	}], (0, _toConsumableArray3.default)(transformations || []), [transformation]).filter(_ramda2.default.identity);

	var src = cl.url(url || cloudinaryID || cloudinaryId, {
		secure: true,
		type: url ? "fetch" : undefined,
		transformation: allTransformations
	});

	return _react2.default.createElement(
		_reactImageloader2.default,
		{
			src: src,
			preloader: renderPreloader,
			wrapper: _react2.default.DOM.div,
			imgProps: {
				width: width || "100%",
				height: height || "auto"
			}
		},
		"Image load failed!"
	);
});

CloudinaryImage.commonTransforms = {
	smartSquare: {
		aspect_ratio: 1,
		gravity: "auto",
		crop: "fill"
	}
};

exports.default = CloudinaryImage;

//# sourceMappingURL=cloudinaryImage.js.map


//////////////////
// WEBPACK FOOTER
// ./~/codogo-react-widgets/dist/components/cloudinaryImage.js
// module id = 132
// module chunks = 0